<template>
  <div class="p-2 shadow dark:bg-charcoal-900">
    <u-button block icon="i-ri-t-box-line" @click="addTextBox">Add a Text Box</u-button>
  </div>
  <div class="flex-1 overflow-y-auto scrollbar-light dark:scrollbar-dark p-3">
    <surface-editor-core-panel-section-heading>Default Text Styles</surface-editor-core-panel-section-heading>
    <div class="grid grid-cols-1 gap-2">
      <button
        v-for="text in defaultTextElements"
        class="rounded-md border border-gray-200  hover:border-gray-300 bg-white hover:bg-gray-100  p-3  transition-colors"
        :id="text.id"
        :style="{
          fontSize: `${text.conf.content.font_size}pt`,
          lineHeight: `${text.conf.content.line_height}`,
          fontFamily: text.conf.content.font_family,
          textAlign: text.conf.content.align,
          fontWeight: text.conf.content.bold ? 600 : 'normal',
          fontStyle: text.conf.content.italic ? 'italic' : 'normal',
          textDecoration: (text.conf.content.underline || text.conf.content.strikethrough)
            ? `${text.conf.content.underline ? 'underline' : ''} ${text.conf.content.strikethrough ? 'line-through' : ''}`
            : 'none',
          color: text.conf.content.color
        }"
        draggable="true"
        @dragstart="event => onDragStart(event, text)"
        @dragend="onDragEnd"
        @click="createText(text)"
      >
        {{text.label}}
      </button>
    </div>

    <template v-if="dynamicTextElements.length">
      <surface-editor-core-panel-section-heading class="mt-4">From your file</surface-editor-core-panel-section-heading>
      <div class="grid grid-cols-1 gap-2">
        <button
          v-for="text in dynamicTextElements"
          class="rounded-md border border-gray-200  hover:border-gray-300 bg-white hover:bg-gray-100  p-3  transition-colors"
          :id="text.id"
          :style="{
            fontSize: `${text.conf.content.font_size}pt`,
            lineHeight: `${text.conf.content.line_height}`,
            fontFamily: text.conf.content.font_family,
            textAlign: text.conf.content.align,
            fontWeight: text.conf.content.bold ? 600 : 'normal',
            fontStyle: text.conf.content.italic ? 'italic' : 'normal',
            textDecoration: (text.conf.content.underline || text.conf.content.strikethrough)
              ? `${text.conf.content.underline ? 'underline' : ''} ${text.conf.content.strikethrough ? 'line-through' : ''}`
              : 'none',
            color: text.conf.content.color
          }"
          draggable="true"
          @dragstart="event => onDragStart(event, text)"
          @dragend="onDragEnd"
          @click="createText(text)"
        >
          {{text.label}}
        </button>
      </div>
    </template>
  </div>
</template>

<script setup>
  //todo: dynamic sizing of these needs to be figured out

  import {storeToRefs} from 'pinia';
  const surfaceEditorStore = useSurfaceEditorStore();
  const {activeSurface, conf} = storeToRefs(surfaceEditorStore);
  const {setDragPayload, clearDragPayload} = useSurfaceEditorDragState();

  const {getTextPresets, buildTextElement} = useSurfaceEditorElementFactory();

  const textPresetGroups = computed(() => getTextPresets(activeSurface.value, {
    dynamicTextData: conf.value?.dynamicTextData
  }));
  const defaultTextElements = computed(() => textPresetGroups.value.defaultPresets || []);
  const dynamicTextElements = computed(() => textPresetGroups.value.dynamicPresets || []);
  const bodyPreset = computed(() => defaultTextElements.value.find((text) => text.id === 'body'));

  function onDragStart(event, text) {
    const dataTransfer = event.dataTransfer;

    if (!dataTransfer) {
      return;
    }

    const payload = {
      type: 'text',
      id: text.id,
      preset: text
    };

    dataTransfer.setData('application/json', JSON.stringify(payload));
    dataTransfer.setData('text/plain', text.id);
    dataTransfer.effectAllowed = 'copy';
    setDragPayload(payload);
  }

  function onDragEnd() {
    clearDragPayload();
  }

  function createText(text) {
    const element = buildTextElement({preset: text, surface: activeSurface.value});

    if (!element) {
      return;
    }

    surfaceEditorStore.addElement({element, surface: activeSurface.value});
  }

  function addTextBox() {
    if (!bodyPreset.value) {
      return;
    }

    const preset = {
      ...bodyPreset.value,
      conf: {
        ...bodyPreset.value.conf,
        content: {
          ...bodyPreset.value.conf.content,
          text: 'Add Text Here'
        }
      }
    };

    createText(preset);
  }

</script>
